import { TextField, ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import { Formik, useFormik } from "formik";
import * as yup from "yup";

export default function ChangePassword() {
  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const initialValues = {
    current: "",
    new: "",
    retype: "",
  };

  const validationSchema = yup.object({
    current: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      .required("Required"),
    new: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      .required("Required"),
    retype: yup
      .string()
      //   .min(1000000000, "Please type atleast 10 digits")
      //   .max(10000000000, "Maximum length of mobile number is 10")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      //   SearchPost(values);
      // console.log("formikvalues", values);
    },
  });

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <section class="cmp">
          <div class="container-fluid">
            {/* <div class="row"> */}

            {/* <section class="col-md-9 right_panel px-0"> */}
            {/* <!--header-section--> */}
            <header class="header_1 py-1">
              <div class="container-fluid">
                <div class="float-end d-flex d_block align-items-center">
                  <a
                    href="#"
                    class="btn_primary d-block d_inline_flex align-items-center py-1 px-4"
                  >
                    <span class="d-block spn_8 text-capitalize">
                      click here to
                    </span>
                    <span class="d-block text-uppercase ms_2">buy now!</span>
                  </a>
                  <div class="d-flex align-items-center d_fx ms-4">
                    <div class="">
                      {/* <!-- <div class="flt_end"> --> */}
                      <div class="float-end d-flex align-items-center spn_9">
                        <i class="fas fa-envelope d-block"></i>
                        <span class="d-block text-capitalize ms-2">
                          sunday,22-july-2018-04:26:14 PM
                        </span>
                      </div>
                      {/* <!-- </div> --> */}
                      <div class="d-flex chanl cl_both">
                        <span class="d-block text-capitalize">promo : 224</span>
                        <span class="d-block text-capitalize mx-3">
                          trans : 17
                        </span>
                        <span class="d-block text-capitalize">
                          miss call : 0
                        </span>
                        <span class="d-block text-capitalize ms-3">
                          IBalance : 0.0000
                        </span>
                      </div>
                    </div>
                    <div class="flt_end ms-4 m_0">
                      <div class="dropdown d_block float_end">
                        <a
                          class="btn profile_8 d-flex align-items-center dropdown-toggle p-0"
                          href="#"
                          role="button"
                          id="dropdownMenuLink"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="fas fa-user d-block"></i>
                          <span class="d-block text-uppercase mx-1">demo1</span>
                        </a>
                        <div
                          class="dropdown-menu m-0 sub_mnu pt-4 pb-0"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <div class="d-flex justify-content-between prfl_8">
                            <a class="d-block">
                              <i class="fas fa-user d-block text-center"></i>
                              <span class="d-block text-capitalize">
                                profile
                              </span>
                            </a>
                            <a class="d-block">
                              <i class="fas fa-wallet d-block text-center"></i>
                              <span class="d-block text-capitalize">
                                wallet
                              </span>
                            </a>
                            <a class="d-block">
                              <i class="fas fa-key d-block text-center"></i>
                              <span class="d-block text-capitalize">
                                password
                              </span>
                            </a>
                          </div>
                          <div class="my-2 px-2">
                            <h6 class="text-center text-capitalize m-0">
                              account manager : raj mishra
                            </h6>
                            <div class="d-flex justify-content-center align-items-center eml_mn my-1">
                              <i class="fas fa-mobile-alt d-block"></i>
                              <span class="d-block">:</span>
                              <span class="d-block ms-2">9876099999</span>
                            </div>
                            <div class="d-flex justify-content-center align-items-center eml_mn">
                              <i class="fas fa-envelope d-block"></i>
                              <span class="d-block">:</span>
                              <span class="d-block ms-2">info@stripl.in</span>
                            </div>
                          </div>
                          <div class="log_out">
                            <i class="fas fa-lock d-block text-center"></i>
                            <span class="d-block text-uppercase text-center mt-1">
                              {" "}
                              log out
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            {/* <!--x-header-section-x--> */}
            <div class="container-fluid_1">
              {/* <!--marquee-section--> */}
              <section class="marquee_8">
                <div class="d-flex justify-content-between">
                  <marquee>
                    wdvfwerve wrevwer vwewer wevwer errwfrv erwvervr wevevrrvew
                    wvervwervwe
                  </marquee>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modl"
                    aria-label="Close"
                  ></button>
                </div>
              </section>
              {/* <!--x-marquee-section-x--> */}
              {/* <!--change-password-section--> */}
              <section class="chng_pwd sms_8 my-4">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex  align-items-center">
                    <i class="fas fa-key d-block"></i>
                    <h6 class="text-uppercase m-0 mx-1">change password /</h6>
                    <p class="text-capitalize m-0">welcome demo1</p>
                    <i class="fas fa-info-circle d-block ms-1"></i>
                  </div>
                  <p class="text-capitalize">home / change password</p>
                </div>
                <div class="w-60 mt-3">
                  <p class="fw-bold">
                    Its been so long that you have not changed your
                    password.Please change it for security purpose.
                  </p>
                </div>
              </section>
              {/* <!--x-change-password-section-x--> */}
              <ThemeProvider theme={theme}>
                <form
                  onSubmit={formik.handleSubmit}
                  role="form"
                  className="text-start"
                >
                  <div class="row justify-content-between rw mx-0">
                    <div class="col-1 px-0">
                      {/* <!--change-password-form-section--> */}
                      <section class="pswrd sms_form py-2">
                        <h6 class="text-capitalize">change my password</h6>

                        <div class="">
                          {/* <label for="exampleInputEmail1" class="form-label text-capitalize">current password</label> */}
                          {/* <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter current password"/> */}
                          <TextField
                            autoComplete="on"
                            className="ms-4 w-50"
                            type="text"
                            label="Current Password"
                            name="current"
                            variant="outlined"
                            size="small"
                            required
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <Tooltip
                            //         title="Mobile Number"
                            //         placement="top"
                            //         arrow
                            //         sx={{ color: "#85CBF2" }}
                            //       >
                            //         <InfoIcon />
                            //       </Tooltip>
                            //     </InputAdornment>
                            //   ),
                            // }}
                            onChange={formik.handleChange}
                            value={formik.values.current}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.current &&
                              Boolean(formik.errors.current)
                            }
                            helperText={
                              formik.touched.current && formik.errors.current
                            }
                          />
                        </div>
                        <div class="my-2">
                          {/* <label for="exampleInputEmail1" class="form-label text-capitalize">new password</label>
                                            <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter new password"/> */}
                          <TextField
                            autoComplete="on"
                            className="ms-4 w-50"
                            type="text"
                            label="New Password"
                            name="new"
                            variant="outlined"
                            size="small"
                            required
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <Tooltip
                            //         title="Mobile Number"
                            //         placement="top"
                            //         arrow
                            //         sx={{ color: "#85CBF2" }}
                            //       >
                            //         <InfoIcon />
                            //       </Tooltip>
                            //     </InputAdornment>
                            //   ),
                            // }}
                            onChange={formik.handleChange}
                            value={formik.values.new}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.new && Boolean(formik.errors.new)
                            }
                            helperText={formik.touched.new && formik.errors.new}
                          />
                        </div>
                        <div class="">
                          {/* <label for="exampleInputEmail1" class="form-label text-capitalize">retype password</label>
                                            <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Retype password"/> */}
                          <TextField
                            autoComplete="on"
                            className="ms-4 w-50"
                            type="text"
                            label="Retype Password"
                            name="retype"
                            variant="outlined"
                            size="small"
                            required
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <Tooltip
                            //         title="Mobile Number"
                            //         placement="top"
                            //         arrow
                            //         sx={{ color: "#85CBF2" }}
                            //       >
                            //         <InfoIcon />
                            //       </Tooltip>
                            //     </InputAdornment>
                            //   ),
                            // }}
                            onChange={formik.handleChange}
                            value={formik.values.retype}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.retype &&
                              Boolean(formik.errors.retype)
                            }
                            helperText={
                              formik.touched.retype && formik.errors.retype
                            }
                          />
                        </div>
                        <button
                          type="submit"
                          class="btn btn-primary d-block m-0 mt-4"
                        >
                          Primary
                        </button>
                      </section>
                      {/* <!--x-change-password-form-section-x--> */}
                    </div>
                    <div class="col-1 px-0 mnt_1">
                      {/* <!--announcement-section--> */}
                      <section class="announcement py-3">
                        <h4 class="">important announcement</h4>
                        <p class="my-3">
                          vfsdjafvbh scfbwdbhfbhwe vdsdbhvbhwehbrf
                          fewbhewgbhdecbhw fvdsbhewhfwe dvbuivfbewghf
                          febvyfwgbfbweb csdvgewgvfg sefvgewgrfv cfvwefgvgwer
                          cewegfvygvewr cdwevfgvygwefy ewrfvgyweygifr
                          fewvgvifwgyuf vfgfevyf frvbwerf vfvyfweygvfr
                          fevyfwgvgyfrew frevwgyfewgyfew fvgfevyife
                          wefbvuyfvfeyg efvyygifgyfygvf efvvyfewevyfew
                          fwgeygyfvyfew fvyfggwfeygyf vyerfgyifgyfgyufe
                          fgygyfgfegfei febvfeggyefgfegife fevyfgewgvfrygif
                          fewvgfrgvgyfeiy evffggvfevgyfegvgfew
                          feawbhvfhbwhfhbfwe febvfgvgfgfegyf
                        </p>
                        <p class="pgph">
                          This price change will be applicable on your account's
                          remaining credits as well & the account balances would
                          be adjusted post 15th May 2018
                        </p>
                      </section>
                      {/* <!--x-announcement-section-x--> */}
                    </div>
                  </div>
                </form>
              </ThemeProvider>

              {/* </div> */}
              {/* </section> */}
              {/* <!--x-right-panel-section-x--> */}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
